import { createTheme, ThemeProvider } from '@mui/material';

let theme = createTheme();

export const appTheme = createTheme({
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          body1: 'div',
          body2: 'div',
          inherit: 'div',
        },
      },
      styleOverrides: {
        h1: { fontSize: 48, fontWeight: 700, fontFamily: 'Space Grotesk, Poppins, sans-serif' },
        h2: { fontSize: 36, fontWeight: 700, fontFamily: 'Space Grotesk, Poppins, sans-serif' },
        h3: { fontSize: 24, fontWeight: 700, fontFamily: 'Space Grotesk, Poppins, sans-serif' },
        h4: { fontSize: 20, fontWeight: 700, fontFamily: 'Space Grotesk, Poppins, sans-serif' },
        h5: { fontSize: 16, fontWeight: 700, fontFamily: 'Space Grotesk, Poppins, sans-serif' },
        h6: { fontSize: 14, fontWeight: 700, fontFamily: 'Space Grotesk, Poppins, sans-serif' },
        subtitle1: { fontSize: 16, fontWeight: 500 },
        subtitle2: { fontSize: 14, fontWeight: 500 },
        body1: { fontSize: 16 },
        body2: { fontSize: 14 },
      },
    },
    MuiContainer: {
      styleOverrides: {
        maxWidthLg: {
          maxWidth: 'calc(1280px + 48px) !important',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        color: 'primary',
        size: 'medium',
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontFamily: 'Poppins, sans-serif',
        },
        containedPrimary: {
          background: '#C685F9',
          color: '#3C3C3E',
          '&.Mui-disabled': {
            background: 'gba(255, 255, 255, 0.1)',
            color: '#5D5D72',
          },
        },
        contained: {
          '&.MuiButton-containedError': {
            background: '#FF5630',
            color: '#FFF',
            border: '2px solid silver',
            '&:hover': {
              background: '#FF3630',
            },
            '&:before': {
              content: '""',
              position: 'absolute',
              inset: 0,
              background: `url(${require('assets/designs/dots-white.png')}) no-repeat center right -20px`,
            },
          },
        },
        sizeLarge: { minHeight: 48, minWidth: 48 },
        sizeMedium: { minHeight: 40, minWidth: 40 },
        sizeSmall: { minHeight: 32, minWidth: 32 },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        focused: true,
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            color: '#FFF',
            '&.Mui-focused fieldset': {
              borderColor: '#5E6484',
            },
            '& .MuiSvgIcon-root': {
              color: '#FFF',
            },
          },
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        tooltip: {
          fontSize: 14,
          backgroundColor: '#1E1F24',
          border: '1px solid #555B68',
          padding: '8px 16px',
          fontWeight: 400,
        },
      },
    },
    MuiLink: {
      defaultProps: {
        target: '_blank',
        underline: 'none',
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
        root: {
          '& .MuiBackdrop-root': {
            background: 'rgba(24, 24, 24, 0.9)',
          },
        },
      },
    },
    MuiPopover: {
      defaultProps: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        transformOrigin: { vertical: 'top', horizontal: 'right' },
        PaperProps: {
          style: {
            backgroundColor: '#372e49cc',
            color: '#fff',
            marginTop: 8,
            border: '1px solid #624266',
          },
        },
      },
    },
    MuiPagination: {
      defaultProps: {
        variant: 'outlined',
        shape: 'rounded',
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#27233A',
          color: '#FFF',
        },
        body: {
          backgroundColor: '#141416',
          color: '#FFF',
        },
        root: {
          border: '1px solid #33363D',
          [theme.breakpoints.between('md', 'lg')]: {
            padding: '12px !important',
          },
          [theme.breakpoints.between('sm', 'md')]: {
            padding: '8px !important',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          border: 'none',
          color: '#FFF',
          background: '#141416',
          width: '100%',
          '&.Mui-disabled': {
            color: '#87878D',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: 'Poppins, Segoe UI Variable, sans-serif',
  },
  palette: {
    primary: {
      main: '#C685F9',
    },
  },
  shape: {
    borderRadius: 8,
  },
});

const Theme = ({ children }) => {
  return <ThemeProvider theme={appTheme}>{children}</ThemeProvider>;
};

export default Theme;
